import React from "react";
import { Box } from "@mui/material";
import CurrentPrice from "@components/current-price";

interface OrderSummaryProps {
  currentPrice: number | null;
  /** Pre-credit goods for the free-shipping caption; see `CurrentPrice`. */
  goodsCents?: number | null;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ currentPrice, goodsCents }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
      <CurrentPrice currentPrice={currentPrice} goodsCents={goodsCents} />
    </Box>
  );
};

export default OrderSummary;
